import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=2796a280&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=2796a280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796a280",
  null
  
)

export default component.exports